    export interface IEditRolesRequest {
        email: string;
        roles: Array<string>;
    }

    export class EditRolesRequest implements IEditRolesRequest {
        email: string;
        roles: Array<string>;
    }